/**
 * Chart-snapshot load outcome for the queue and Rules pages.
 *
 * Kept off `ChartSnapshot` (types.ts). A failed GET is not the same as
 * `present: false`: the Worker may still have a snapshot we failed to
 * fetch, so the chooser must refuse without claiming the chart has never
 * been loaded.
 */
import {
  absentChartSnapshot,
  type ChartSnapshot,
  type CompanySlug,
} from "./types.js";

export type ChartLoadState =
  | { status: "ok"; snapshot: ChartSnapshot }
  | { status: "absent"; snapshot: ChartSnapshot }
  | { status: "error"; snapshot: ChartSnapshot; message: string };

export const CHART_LOAD_ERROR_MESSAGE =
  "The chart could not be loaded. Try again from the top of the page.";

export function chartLoadFromSnapshot(snapshot: ChartSnapshot): ChartLoadState {
  if (snapshot.present) {
    return { status: "ok", snapshot };
  }
  return { status: "absent", snapshot };
}

export function chartLoadFromError(
  company: CompanySlug,
  message: string = CHART_LOAD_ERROR_MESSAGE,
): ChartLoadState {
  return { status: "error", snapshot: absentChartSnapshot(company), message };
}
